import { memo, useMemo } from "react";

import { Outlet, useLocation } from "react-router-dom";

import { CustomTitleBar } from "../CustomTitleBar/CustomTitleBar";

import { LayoutContainer, ContentContainer } from "./AppLayout.styles";

import { useDeepLinkAuth } from "../../hooks/useDeepLinkAuth";

import { useSessionValidator } from "../../hooks/useSessionValidator";

import { SessionExpiredModal } from "../SessionExpiredModal";

const AppLayout = () => {
  const location = useLocation();

  useDeepLinkAuth();

  const sessionExpired = useSessionValidator();

  // Show simple title bar (only window controls) on login and install pages

  const isUnauthenticatedPage = useMemo(
    () =>
      location.pathname === "/" ||
      location.pathname === "/signup" ||
      location.pathname === "/forgot-password" ||
      location.pathname === "/install",

    [location],
  );

  return (
    <LayoutContainer>
      <CustomTitleBar height={32} simpleMode={isUnauthenticatedPage} />
      <ContentContainer>
        <Outlet />
      </ContentContainer>
      <SessionExpiredModal open={sessionExpired} />
    </LayoutContainer>
  );
};

export default memo(AppLayout);
